module.exports = __webpack_public_path__ + "static/media/send-money.ed07d39f.svg";